/**
 * Pass dialog — captures WHY a brand is rejected, stored as the brand
 * decision's `notes`. The reasons are deliberately free text: they're
 * training data for automating the filter later ("brand sells it
 * themselves", "margins too thin", "seasonal fad" …), so the field nudges
 * but never blocks — an empty pass is still a pass.
 */
import { useState } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../design';

export function PassDialog({
  brandName,
  open,
  passing,
  onConfirm,
  onClose,
}: {
  brandName: string;
  open: boolean;
  passing: boolean;
  onConfirm: (reason: string) => void;
  onClose: () => void;
}) {
  const [reason, setReason] = useState('');

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Pass on {brandName}</DialogTitle>
        </DialogHeader>

        <div>
          <p className="text-sm text-fg-secondary mb-2">
            Why pass? A short reason teaches Sourcito what to filter out for you.
          </p>
          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            rows={3}
            maxLength={2000}
            autoFocus
            placeholder="e.g. brand sells it themselves · margins too thin · seasonal fad · too big for us"
            className="w-full text-sm rounded-sm border border-border-subtle bg-canvas px-3 py-2 focus:outline-none focus:ring-1 focus:ring-accent-fg"
          />
        </div>

        <DialogFooter>
          <Button variant="secondary" onClick={onClose} disabled={passing}>
            Cancel
          </Button>
          <Button loading={passing} onClick={() => onConfirm(reason.trim())}>
            Pass
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
